<template>
  <div id="containerLeft">
    <v-card class="card_tree_left" v-if="getGameConsole === 'default'">
      <!--style="position:-webkit-sticky; position:sticky; top:0;"-->
      <!--<QuickBet v-if="(getType==4 || (getType==2 && getCashier)) && this.getLiveMode == 'preview'"></QuickBet>-->
      <tree
        v-if="
          this.getLiveMode == 'preview' ||
          checkIsMobile() ||
          checkIsTablet() ||
          !getSettings.enableLive
        "
      ></tree>
      <LiveEventsVerticalScroller
        v-else-if="getSettings.enableLive"
      ></LiveEventsVerticalScroller>
    </v-card>

    <v-card class="card_tree_left_v2" v-if="getGameConsole === 'marketview'">
      <tree-v2
        v-if="
          this.getLiveMode == 'preview' ||
          checkIsMobile() ||
          checkIsTablet() ||
          !getSettings.enableLive
        "
      ></tree-v2>
      <LiveEventsVerticalScroller
        v-else-if="getSettings.enableLive"
      ></LiveEventsVerticalScroller>
    </v-card>
  </div>
</template>

<script>
// import tree from "@/components/left_widgets/Tree";
import SidebarSettings from '@/components/left_widgets/SidebarSettings'
import LiveEventsVerticalScroller from '@/components/left_widgets/LiveEventsVerticalScroller'
import QuickBet from '@/components/left_widgets/QuickBet'
import { mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'

const tree = () => ({
  component: import('@/components/left_widgets/Tree'),
  loading: LoadingSkeleton,
  timeout: 1000,
})

const treeV2 = () => ({
  component: import('@/components/left_widgets/TreeV2'),
  loading: LoadingSkeleton,
  timeout: 1000,
})

export default {
  name: 'Left',
  components: {
    SidebarSettings,
    tree,
    LiveEventsVerticalScroller,
    QuickBet,
    LoadingSkeleton,
    treeV2,
  },
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
  }),

  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getType: 'user/getType',
      getCashier: 'user/getCashier',
      getLiveMode: 'odds/getLiveMode',
      getSettings: 'cart/getSettings',
      getGameConsole: 'settings/getGameConsole',
    }),
  },
  methods: {
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
  },
}
</script>
